import queryString from 'query-string';

import { Environment } from 'utils';

export const API_ROOT = `${Environment.getPublicUrl()}/api`;
export const ENDPOINT_AUTHENTICATION_LOGOUT = `${API_ROOT}/redirect?${queryString.stringify(
  { redirectTo: window.location.href }
)}`;
